import React, { useCallback, useState } from "react";

import Select from "../../../select";
import Modal from "common-ui-components/components/modal";
import TableControlButton from "../TableControlButton";
import Button from "common-ui-components/components/button";
import { CheckBox } from "common-ui-components/components/input";

import { useTableManagerContext } from "../../TableManagerContext";

import styles from "./Export.module.css";

import {useSelector} from "react-redux";
import exportIcon from "../../../icons/export.svg";
import { Password } from "common-ui-components/components/input";
import {API_URL, PRODUCT_ID} from "common-ui-components/components/utils/Config";
import { useTableConfiguration } from "../../table-manager-hooks";

const serverUrl = API_URL;

const Export = ({ handleAction }) => {
  const { setTableControls } = useTableManagerContext();

  const [exportOption, setExportOption] = useState("");

  const [open, setOpen] = useState(false);

  const handleCancel = () => {
    setOpen(false);
    setExportOption("");
  };

  const handleExportSelect = (option, _index) => {
    setOpen(true);
    setExportOption(option);
  };

  const handleExportClose = useCallback(() => {
    setTableControls((prevTableControls) => ({
      ...prevTableControls,
      export: false,
    }));
  }, [setTableControls]);

  return (
      <>
        <Select
            triggerComponent={TableControlButton}
            triggerProps={{
              name: "Export",
              icon: exportIcon,
              control: "export",
              handleAction,
              withoutButton: true,
            }}
            active={-1}
            options={["XLSX", "CSV", "PDF"]}
            onClose={handleExportClose}
            onOptionSelect={handleExportSelect}
        />
        <Modal {...{ open, setOpen, className: styles.exportModalWrapper }}>
          <ExportModalContent
              exportOption={exportOption}
              onCancel={handleCancel}
          />
        </Modal>
      </>
  );
};

const ExportModalContent = ({ exportOption, onCancel }) => {
  const [actualUrl] = useTableManagerContext().url.split("?");

  const paramUrl = useTableManagerContext().url;

  const deviceId  =  useSelector((state) => state.id.deviceId);
  const softwareId  =  useSelector((state) => state.id.softwareId);
  const hardwareId  =  useSelector((state) => state.id.hardwareId);


  const [password, setPassword] = useState("");

  const [protect, setProtect] = useState(false);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleProtectCheck = (e) => {
    setProtect(e.target.checked);
    if (!e.target.checked) setPassword("");
  };

  const handleCancel = () => {
    setPassword("");
    setProtect(false);
    onCancel();
  };

  const { tableConfig } = useTableConfiguration();
  const { columnsToDisplay : columns } = useTableManagerContext();
  const handleExport = async () => {
    try {

      // If paramUrl is relative, add base origin for URL constructor to work
      const urlObj = new URL(paramUrl, window.location.origin);

      const extras = Array.from(urlObj.searchParams.entries());

      // Build base params
      const tableIdentifier = actualUrl.split('/').at(-1);
      const browserUrl = window.location.href;
//      const reportId = browserUrl.split('/').at(-1);
      const segments = browserUrl.split('/').filter(Boolean);

      let reportId = '';

      if (segments.includes('view')) {
        reportId = segments[segments.indexOf('view') + 1];
      } else if (segments.includes('report-details')) {
        reportId = segments[segments.indexOf('report-details') + 1];
      }

      // Base query params
      const params = new URLSearchParams();

      // Always send
      params.append("productId", PRODUCT_ID);
      params.append("tableIdentifier", tableIdentifier);

      // Send only when value exists
      // if (deviceId) {
      //   params.append("deviceId", deviceId);
      // }
      // if (softwareId) {
      //   params.append("softwareId", softwareId);
      // }
      // if (hardwareId) {
      //   params.append("hardwareId", hardwareId);
      // }
      if (reportId) {
        params.append("reportId", reportId);
      }

      // Add extras to params
      extras.forEach(([key, value]) => {
        params.append(key, value);
      });

      // Add password param if applicable (for PDF/XLSX)
      // if ((exportOption === "PDF" || exportOption === "XLSX") && password) {
      //   params.append("password", password);
      // }

      //console.log(params.toString());

      // Determine endpoint path based on export option
      let endpoint = "";
      if (exportOption === "CSV") {
        endpoint = "/export/exportCSV";
      } else if (exportOption === "PDF") {
        endpoint = "/export/exportPDF";
      } else if (exportOption === "XLSX") {
        endpoint = "/export/exportXLSX";
      }

      const normalizedColumns = columns
          .filter(col => col.title && col.accessor && !col.ignoreDuringExport && col.accessor !== "__action__")
          .map(col => ({
            title: col.title,
            accessor: col.accessor,
          }));

      //console.log({normalizedColumns})
      //console.log({tableConfig})

      // Full URL
      const exportUrl = `${serverUrl}${endpoint}?${params.toString()}`;

      const form = document.createElement("form");
      form.method = "POST";
      form.action = exportUrl;
      form.target = "_blank";

      const appendHiddenInput = (name, value) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
      };

      appendHiddenInput("columns", JSON.stringify(normalizedColumns));
      appendHiddenInput("sort", JSON.stringify(tableConfig.sort));
      appendHiddenInput("search", JSON.stringify(tableConfig.search));
      appendHiddenInput("filter", JSON.stringify(tableConfig.filter));

      if ((exportOption === "PDF" || exportOption === "XLSX") && password) {
        appendHiddenInput("password", password);
      }

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

      setPassword("");
      setProtect(false);
      onCancel();

      // Trigger download by opening URL in new tab
      // const link = document.createElement("a");
      // link.href = exportUrl;
      // link.target = "_blank";
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);

      // setPassword("");
      // setProtect(false);
      // onCancel();

    }
    catch (error)
    {
      console.error("Export failed:", error);
    }
  };


  return (
      <div className={styles.exportModalContent}>
        <h5 style={{ marginBottom: 0 }}>Export as {exportOption}</h5>
        {exportOption!=="CSV" &&
            <p style={{ marginBottom: 0 }}>
              To keep the list secure, you can protect the exported file with a
              password.
            </p>
        }
        {exportOption!=="CSV" &&
          <div className={styles.protectPasswordCheckbox}>
            <CheckBox
                checked={protect}
                label="Protect this file using password"
                scaleIcon={0.75}
                onChange={handleProtectCheck}
            />
          </div>
        }
        {exportOption==="CSV" &&
            <p style={{ marginBottom: 0 }}>
              Do you want to export as CSV?
            </p>
        }
        {protect && <Password value={password} onChange={handlePasswordChange} />}
        <div className={styles.btnPanel}>
          <Button className={styles.btn} onClick={handleCancel}>
            Cancel
          </Button>
          <Button type="submit" className={styles.btn} onClick={handleExport}>
            Export
          </Button>
        </div>
      </div>
  );
};

export default Export;